<template>
  <div>
    <Keypress
      key-event="keydown"
      :prevent-default="true"
      @success="onKeyUpSuccess"
      :multiple-keys="getMultipleKeys"
      :modifiers="['ctrlKey', 'metaKey', 'altKey']"
      @any="onAnyKey"
    />
    <!-- @wrong="onKeyWrong" -->
  </div>
</template>

<script>
import routeMixin from "../_mixins/route.mixin";
import FormMixin from "../_mixins/form.mixin";
import { mapGetters } from "vuex";
export default {
  mixins: [routeMixin, FormMixin],
  props: {
    triggerdFrom: {
      type: String,
      default: "default",
    },
  },
  methods: {
    onKeyUpSuccess(e) {
      // eslint-disable-next-line no-console
      // console.log("onKeyUpSuccess - ", this.triggerdFrom, " - ", e);
      if (this.$store.state.ui.isSubmitting) {
        // eslint-disable-next-line no-console
        console.log(
          "INFO: Request processing in Progress. Cannot proceed until the current processing is completed."
        );
        return;
      }

      if (
        (((e.event.ctrlKey || e.event.metaKey || e.event.altKey) &&
          e.event.keyCode == 83) ||
          e.event.keyCode == 120) &&
        this.baseView &&
        (this.baseView.mode == "create" ||
          this.baseView.mode == "edit" ||
          this.getHotKeyPopupMode)
      ) {
        let editIconElement = document.querySelectorAll(
          ".dx-icon.dx-icon-floppy"
        );

        this.focusOutOnEditors();
        if (editIconElement.length > 0) {
          let buttonElement = editIconElement[0].parentElement.parentElement;
          if (buttonElement.classList.contains("dx-dropdownbutton-action"))
            this.$store.dispatch("hotKey/setHotKeySave", true);
          else buttonElement.click();
        } else this.$store.dispatch("hotKey/setHotKeySave", true);
      }
      if (
        ((e.event.ctrlKey || e.event.metaKey || e.event.altKey) &&
          e.event.keyCode == 70) ||
        e.event.keyCode == 113
      ) {
        let searchBox = document.querySelectorAll(
          "input[aria-label='Search in the data grid']"
        );

        if (searchBox) searchBox[0].focus();
        else this.$store.dispatch("hotKey/setHotKeyFilterFocus", true);
      }

      if (
        (e.event.ctrlKey || e.event.metaKey || e.event.altKey) &&
        e.event.keyCode == 78
      ) {
        let addNewBtn = document.querySelectorAll(
          ".dx-button[aria-label='Add New']"
        );
        if (addNewBtn && addNewBtn.length > 0) addNewBtn[0].click();
        else this.$store.dispatch("hotKey/setHotKeyCreateNew", true);
      }

      if (
        (e.event.ctrlKey || e.event.metaKey || e.event.altKey) &&
        e.event.keyCode == 69
      ) {
        let editIconElement = document.querySelectorAll(
          ".dx-icon.dx-icon-edit"
        );
        if (editIconElement.length > 0) {
          let buttonElement = editIconElement[0].parentElement.parentElement;
          if (!buttonElement.classList.contains("dx-state-invisible")) {
            buttonElement.click();
          }
        } else this.$store.dispatch("hotKey/setHotKeyEdit", true);
      }
    },
    // onKeyWrong(e) {
    //   // eslint-disable-next-line no-console
    //   // console.log("onKeyWrong - ", this.triggerdFrom, " - ", e);
    // },
    onAnyKey(e) {
      // eslint-disable-next-line no-console
      // console.log("onAnyKey - ", this.triggerdFrom, " - ", e);
      if (e.event.keyCode == 27) {
        var backBtn = Array.from(
          document.querySelectorAll(
            "div.dx-popup-normal:not(.dx-state-invisible) .dx-button .dx-button-text"
          )
        ).find((el) => el.textContent.toLocaleLowerCase() === "back");

        if (backBtn) backBtn.click();
        else {
          var noBtn = Array.from(
            document.querySelectorAll(
              "div.dx-popup-normal:not(.dx-state-invisible) .dx-button .dx-button-text"
            )
          ).find((el) => el.textContent.toLocaleLowerCase() === "no");

          var calcelBtn = Array.from(
            document.querySelectorAll(
              "div.dx-popup-normal:not(.dx-state-invisible) .dx-button:not(.dx-state-invisible) .dx-button-text"
            )
          ).find((el) => el.textContent.toLocaleLowerCase() === "cancel");

          if (noBtn) noBtn.click();
          else if (calcelBtn) calcelBtn.click();
          else {
            var closeBtn = document.querySelectorAll(
              ".dx-button .dx-icon-close"
            );

            if (closeBtn && closeBtn.length > 0) closeBtn[0].click();
            else {
              var headerBack = document.querySelectorAll(
                ".dx-button .dx-icon-arrowleft"
              );

              if (headerBack && !this.getHotKeyPopupMode) headerBack[0].click();
            }
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      getHotKeyPopupMode: "hotKey/getHotKeyPopupMode",
    }),
    getMultipleKeys() {
      return [
        {
          keyCode: 83, // S - Save
          modifiers: ["ctrlKey"],
          preventDefault: true,
        },
        {
          keyCode: 83, // S - Save
          modifiers: ["metaKey"],
          preventDefault: true,
        },
        {
          keyCode: 120, // F9 - Save
          modifiers: [],
          preventDefault: true,
        },
        {
          keyCode: 70, // F - Focus in filterpanel
          modifiers: ["ctrlKey"],
          preventDefault: true,
        },
        {
          keyCode: 70, // F - Focus in filterpanel
          modifiers: ["metaKey"],
          preventDefault: true,
        },
        {
          keyCode: 113, // F2 - Focus in filterpanel
          modifiers: [],
          preventDefault: true,
        },
        {
          keyCode: 78, // N - create new record
          modifiers: ["ctrlKey"],
          preventDefault: true,
        },
        {
          keyCode: 78, // N - create new record
          modifiers: ["metaKey"],
          preventDefault: true,
        },
        {
          keyCode: 78, // N - create new record
          modifiers: ["altKey"],
          preventDefault: true,
        },
        {
          keyCode: 69, // E - Edit
          modifiers: ["ctrlKey"],
          preventDefault: true,
        },
        {
          keyCode: 69, // E - Edit
          modifiers: ["metaKey"],
          preventDefault: true,
        },
        {
          keyCode: 27, // Esc
          modifiers: [],
          preventDefault: true,
        },
      ];
    },
  },
};
</script>
